
import styles from './styles.module.scss';

import cn from 'classnames';

const TableLine = ({
  isPainted = true,
  isError = false,
  isMinus = false,
  white = true,
  select = false,
  cursor = false,
  children,
  ...props
}) => (
  <div
    className={cn(
      styles.table_line,
      white && styles.table_line_white,
      isError && styles.table_line_red,
      isMinus && styles.table_line_red_hard,
      isPainted && styles.table_line_painted,
      props.styles,
      select && styles.selected,
      cursor && styles.cursor,
    )}
    style={props.style}
    {...props}
  >
    {children}
  </div>
);

export default TableLine;
